<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Mcq question
                </h2>
                <div class="flex items-center space-x-3">
                    <button
                        @click="open = true"
                        class="
                            py-1
                            px-2
                            bg-indigo-500
                            text-white
                            rounded
                            focus:outline-none
                        "
                    >
                        Add Question
                    </button>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        question
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        description
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Group Id
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                            >Edit</span
                                                        >
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        question, index
                                                    ) in questions"
                                                    :key="question.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ question.question }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                        >
                                                            {{
                                                                question.options
                                                                    .description
                                                            }}
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ question.group_id }}
                                                    </td>
                                                    <td class="px-6 py-4">
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    question.live,
                                                                'bg-red-100 text-red-800':
                                                                    !question.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                question.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>

                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button
                                                            @click="destroy(question)"
                                                            class="
                                                                text-red-400
                                                                hover:text-red-600
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            type="button"
                                                            @click="
                                                                edit(question)
                                                            "
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> {{ title }} </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 gap-y-4">
                <div class="block w-full">
                    <label
                        for="type"
                        class="block text-sm font-medium text-gray-700"
                        >question</label
                    >
                    <input
                        v-model="form.question"
                        type="text"
                        name="question"
                        id="question"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.mcq_question.question"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="group_id"
                        class="block text-sm font-medium text-gray-700"
                        >Group Id</label
                    >
                    <select
                        v-model="form.group_id"
                        id="group_id"
                        name="group_id"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Group Id</option>
                        <option v-for="id in group_id" :key="id" :value="id">
                            {{ id }}
                        </option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.mcq_question.group_id"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="description"
                        class="block text-sm font-medium text-gray-700"
                        >Description</label
                    >
                    <input
                        v-model="form.description"
                        type="text"
                        name="description"
                        id="description"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />

                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.mcq_question.description"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Exercise is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.mcq_question.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            form: useForm(
                {
                    id: "",
                    description: "",
                    question: "",
                    group_id: "",
                    live: "",
                },
                {
                    bag: "mcq_question",
                }
            ),
        };
    },
    props: {
        questions: Array,
        exercises: Array,
        group_id: Array,
    },
    computed: {
        title() {
            return this.editItemIndex > -1
                ? "Edit This question"
                : "Add A new question";
        },
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            if (this.editItemIndex > -1) {
                // update request
                this.form.put(
                    route(`admin.mcq-question.update`, this.form.id),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            } else {
                // store request
                this.form.post(route(`admin.mcq-question.store`), {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                });
            }
        },
        edit(question) {
            this.editItemIndex = this.questions.indexOf(question);
            this.form.group_id = question.group_id;
            this.form.description = question.options.description;
            this.form.question = question.question;
            this.form.live = question.live ? 1 : 0;
            this.form.id = question.id;
            this.open = true;
        },
        destroy(question){
            if(confirm('Are you sure about deleting this item?')){
                this.$inertia.delete(route(`admin.mcq-question.destroy`,question.id))
            }
        },
    },
    components: {
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
